import React from 'react'
import HRDashboard from './Dashboard/HRDashboard';
import ManagerDashboard from './Dashboard/ManagerDashboard';
import EmployeeDashboard from './Dashboard/EmployeeDashboard';
import HomeDashboard from './HomeDashboard';
import FinanceDashboard from './Dashboard/FinanceDashboard';
import JumboContentLayoutMain from '@jumbo/components/JumboContentLayout/JumboContentLayoutMain';
import DepartmentManagerDashboard from './Dashboard/DepartmentManagerDashboard';

const Home = () => {
  let userDetails = localStorage.getItem("UserDetails");
  userDetails = JSON.parse(userDetails);
  let Designation = userDetails && userDetails?.Designation;

  const renderDashboard = () => {
    switch (Designation) {
      case "HR":
        // return <HomeDashboard />;
        return <HRDashboard />;
      // return <ManagerDashboard />;
      // return <DepartmentManagerDashboard />;
      // return <EmployeeDashboard />;
      // return <FinanceDashboard />;
      case "HR Manager":
        return <ManagerDashboard />;
      case "Manager":
        return <ManagerDashboard />;
      case "Department Manager":
        return <DepartmentManagerDashboard />;
      case "Finance":
        return <FinanceDashboard />;
      case "Employee":
        return <EmployeeDashboard />;
      case "General Manager":
        return <ManagerDashboard />;
      default:
        return <HomeDashboard />;
    }
  };

  return (
    <JumboContentLayoutMain>
      <div className="dashboard-container">
        {renderDashboard()}
      </div>
    </JumboContentLayoutMain>
  );
};

export default Home;
